import React, { useState, useEffect, useCallback} from 'react'
import { RouteComponentProps } from 'react-router-dom'
import styled from 'styled-components'
import { useDispatch } from 'react-redux'

import { AppDispatch } from '../../state'
import { updateLevel } from '../../state/market/actions'
import { useActiveWeb3React } from '../../hooks'
import useParsedQueryString from '../../hooks/useParsedQueryString'

import { getArtistInfo } from '../../service/user'
import { userInfoEmptyV2 } from '../../constants/usercenter'

import Banner from './components/Banner'
import Overview from './components/Overview'
import Tabs from './components/Tabs'
import UserCreated from './components/UserCreated'
import UserCollected from './components/UserCollected'

const UserMain = styled.div`
  width: 100%;
`

const MainContent = styled.div`
  max-width: 1224px;
  margin: auto;
  box-sizing: border-box;
  padding: 0px 20px;
`


export default function UserCenter ({
  match: {
    params: { owner }
  }
}: RouteComponentProps<{ owner: string }>) {
  const query:any = useParsedQueryString()
  const dispatch = useDispatch<AppDispatch>()
  const { chainId } = useActiveWeb3React()
  const [userInfo, setUserInfo] = useState(userInfoEmptyV2)

  // 获取信息
  const getUserInfo = useCallback(() => {
    getArtistInfo(chainId as number, {address: owner}, (err: any, d: any) => {
      if (!err && d.code === 0) {
        let data = d.data
        data.address = owner
        setUserInfo(data)
      } else {
        setUserInfo(userInfoEmptyV2)
      }
    })
  }, [userInfoEmptyV2, chainId, owner, getArtistInfo])

  useEffect(() => {
    getUserInfo()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getUserInfo])

  dispatch(updateLevel({level: 'v2'}))

  // tabs
  const USER = {
    CREATED: 'CREATED',
    COLLECTED: 'COLLECTED'
  }

  const curTab:any = query.type || USER.CREATED

  return (
    <UserMain>
      <Banner info={userInfo}></Banner>
      <MainContent>
        <Overview info={userInfo} owner={owner}></Overview>
        <Tabs owner={owner} curTab={curTab} USER={USER}></Tabs>
        {
          curTab === USER.CREATED && <UserCreated owner={owner}></UserCreated>
        }
        {
          curTab === USER.COLLECTED && <UserCollected owner={owner}></UserCollected>
        }
      </MainContent>
    </UserMain>
  )
}
